import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatchMakingService } from '@fantaz/shared/data-access/api';
import {
  CasualTournamentDetails,
  CasualTournamentEntity,
  CurrentUser,
  EventSchedule,
} from '@fantaz/shared/data-access/models';
import { ModalAlertComponent } from '@fantaz/shared/ui/modal-alert';
import { MatchMakingDialogComponent } from '@fantaz/tournaments/ui/match-making-dialog';

@Injectable({
  providedIn: 'root',
})
export class PlayTournamentFacade2 {
  constructor(
    private dialog: MatDialog,
    private matchMakingService: MatchMakingService,
  ) {}

  private openDialog(errorType: string, options?: object) {
    this.dialog.open(ModalAlertComponent, {
      data: {
        modalType: errorType,
        ...options,
      },
    });
  }

  private openMatchMakingDialog(options: {
    user: CurrentUser;
    eventPrototypeUuid: string;
    eventScheduleUuid: string;
    entryAmount: number;
    passUuid?: string;
  }) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      user: options.user,
      openTournament: {
        ...options,
        eventPrototypeUuid: options.eventPrototypeUuid,
      },
      scheduleSelected: {
        // ...this.eventSchedule,
        eventScheduleUuid: options.eventScheduleUuid,
        entryAmount: options.entryAmount,
      },
      passUuid: options.passUuid,
    };

    const dialogRef = this.dialog.open(
      MatchMakingDialogComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((successResponse) => {
      if (successResponse) {
        this.matchMakingService.playCasualTournament(successResponse);
      }
    });
  }

  playTournament(options: {
    tournament?: CasualTournamentEntity;
    tournamentDetail?: CasualTournamentDetails;
    eventSchedule: EventSchedule;
    user: CurrentUser;
    location: boolean;
    passUuid?: string;
  }) {
    // validate if user is authenticated
    if (!options.user) {
      this.openDialog('login-error');
    } else if (options.location) {
      this.openDialog('location-error');
    } else if (
      Number(options.user.user?.balance) < options.eventSchedule.entryAmount
    ) {
      this.openDialog('balance-error', {
        secondaryActionText: null,
      });
    } else if (options.user.user?.walletFrozen) {
      this.openDialog(
        `WALLET_FROZEN_${options.user.user?.walletFrozenReason || 'BY_ADMIN'}`,
      );
    } else {
      let eventPrototypeUuid;
      let eventScheduleUuid;

      if (options.tournament) {
        eventPrototypeUuid = options.tournament.uuid;
        eventScheduleUuid = options.eventSchedule.uuid;
      } else {
        eventPrototypeUuid = (
          options.tournamentDetail as CasualTournamentDetails
        ).eventPrototypeUuid as string;
        eventScheduleUuid = (
          options.tournamentDetail as CasualTournamentDetails
        ).eventInstanceUuid as string;
      }

      this.openMatchMakingDialog({
        user: options.user,
        entryAmount: options.eventSchedule.entryAmount,
        eventPrototypeUuid,
        eventScheduleUuid,
        passUuid: options.passUuid,
      });
    }
  }
}
